var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-tabs',{staticClass:"header-tabs",attrs:{"type":_vm.tabType},on:{"change":function (key) { return _vm.$emit('change', key); }}},_vm._l((_vm.data),function(tab){return _c('a-tab-pane',{key:tab.value,attrs:{"tab":tab.name}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f3a4d9d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BaseTab/index.vue
// module id = null
// module chunks = 